export const BANNER_HEIGHT = 40;

export const DESKTOP_APP_BAR_HEIGHT = 61;

export const MOBILE_APP_BAR_HEIGHT = 52;

export const DRAWER_WIDTH = 200;

export const SETTINGS_PAGE_MAX_WIDTH = 1080;
export enum AppViewMode {
  CLIENT = 'client',
  INTERNAL = 'internal',
}
